import { Component, EventEmitter, Inject, Input, OnChanges, Output } from "@angular/core";
import * as E from "linq";
import { CompanyFacetDto } from "../../../../portal/search-api/models/company-facet-dto";
import {MatDialog} from '@angular/material/dialog';
import { SearchWebsitesTagsDialogComponent } from "../search-websites-tags-dialog/search-websites-tags-dialog.component";
import { SearchOptions } from "../../../../storage/contact-search/search.state";
import { Store } from "@ngrx/store";
import { IStore } from "../../../../storage/store";
import * as SearchCompanyActions from "../../../../storage/contact-search/search.actions";

type FilterItem = {
    checked: boolean,
    disabled: boolean,
    caption: string,
};

type SearchFilter = {
    items: FilterItem[],
    collapsed: boolean,
};

type FilterTagItem ={
  type:string;
  caption:string;
}

type AppliedFilterField<T> = Partial<Record<keyof T, FilterItem[]>>;
type AppliedFilter<T> = AppliedFilterField<T> & { filterName: keyof T };
type CompanyAppliedFilter = AppliedFilter<CompanyFacetDto>;
type CompanySearchFilters = Record<keyof CompanyFacetDto, SearchFilter>;

@Component({
    selector: "company-search-result-tags",
    templateUrl: "./company-search-result-tags.component.html",
    styleUrls: ["./company-search-result-tags.component.scss"]
})
export class CompanySearchResultTagsComponent implements OnChanges {

    @Input() filters: CompanySearchFilters;
    @Output() changed = new EventEmitter<CompanyAppliedFilter>();

    employeeRange: string[];
    industry: string[];
    ownership: string[];
    revenueRange: string[];
    location: string[];
    country: string[];
    companyName: string[];
    website:string[];

    constructor(public dialog: MatDialog,private store: Store<IStore>) {}

    triggerChange(filterName: keyof CompanySearchFilters, caption: string) {

        const items = E.from(this.filters[filterName].items)
            .select(i => ({
                ...i,
                checked: i.caption == caption ? false : i.checked
            }))
            .toArray();
         console.log({ filterName, [filterName]: items });
        this.changed.next({ filterName, [filterName]: items });
    }

    showWebsitesList(){

      let itemsEmployeeRange = this.employeeRange.map(x=><FilterTagItem>{caption:x,type:"employeeRange"});
      let itemsIndustry = this.industry.map(x=><FilterTagItem>{caption:x,type:"industry"});
      let itemsOwnership = this.ownership.map(x=><FilterTagItem>{caption:x,type:"ownership"});
      let itemsRevenueRange = this.revenueRange.map(x=><FilterTagItem>{caption:x,type:"revenueRange"});
      let itemsLocation = this.location.map(x=><FilterTagItem>{caption:x,type:"location"});
      let itemsCountry = this.country.map(x=><FilterTagItem>{caption:x,type:"country"});
      let itemsCompanyName = this.companyName.map(x=><FilterTagItem>{caption:x,type:"companyName"});
      let itemsWebsite = (this.website.map(x=><FilterTagItem>{caption:x,type:"website"}));

      let items:FilterTagItem[] = [
        ...itemsEmployeeRange,
        ...itemsIndustry,
        ...itemsOwnership,
        ...itemsRevenueRange,
        ...itemsLocation,
        ...itemsCountry,
        ...itemsCompanyName,
        ...itemsWebsite];

      const dialogRef = this.dialog.open(SearchWebsitesTagsDialogComponent, {
        width: '450px',
        height:'450px',
        maxHeight:'450px;',
        data: {items: items},
      });


      dialogRef.afterClosed().subscribe(result => {

       if(result?.items !== undefined){
        let filterItems : FilterTagItem[] = result?.items;
        let companyAppliedFilters : CompanyAppliedFilter[] = [];

        filterItems.forEach(element => {
          let filterName = this.getFilterName(element.type)
          const items = E.from(this.filters[filterName].items)
          .select(i => ({
              ...i,
              checked: i.caption == element.caption ? false : i.checked
          }))
          .toArray();
          if(companyAppliedFilters.find(x=>x[filterName]) == null) {
            companyAppliedFilters.push({ filterName,[filterName]:items })
          }else{
           companyAppliedFilters.find(x=>x[filterName])[filterName].find(y=>y.caption == element.caption).checked = false;
          }
        });

        companyAppliedFilters.find(x=>x.city) == null ? companyAppliedFilters.push({ filterName:"city",["city"]:this.filters.city.items }):"";
        companyAppliedFilters.find(x=>x.companyName) == null ? companyAppliedFilters.push({ filterName:"companyName",["companyName"]:this.filters.companyName.items }):"";
        companyAppliedFilters.find(x=>x.country) == null ? companyAppliedFilters.push({ filterName:"country",["country"]:this.filters.country.items }):"";
        companyAppliedFilters.find(x=>x.countryState) == null ? companyAppliedFilters.push({ filterName:"countryState",["countryState"]:this.filters.countryState.items}):"";
        companyAppliedFilters.find(x=>x.employeeRange) == null ? companyAppliedFilters.push({ filterName:"employeeRange",["employeeRange"]:this.filters.employeeRange.items }):"";
        companyAppliedFilters.find(x=>x.industry) == null ? companyAppliedFilters.push({ filterName:"industry",["industry"]:this.filters.industry.items }):"";
        companyAppliedFilters.find(x=>x.location) == null ? companyAppliedFilters.push({ filterName:"location",["location"]:this.filters.location.items }):"";
        companyAppliedFilters.find(x=>x.ownership) == null ? companyAppliedFilters.push({ filterName:"ownership",["ownership"]:this.filters.ownership.items }):"";
        companyAppliedFilters.find(x=>x.revenueRange) == null ? companyAppliedFilters.push({ filterName:"revenueRange",["revenueRange"]:this.filters.revenueRange.items }):"";
        companyAppliedFilters.find(x=>x.state) == null ? companyAppliedFilters.push({ filterName:"state",["state"]:this.filters.state.items }):"";
        companyAppliedFilters.find(x=>x.website) == null ? companyAppliedFilters.push({ filterName:"website",["website"]:this.filters.website.items }):"";

          this.companySearchAndFilterChangedAction({hideMyOwnedCompanies:false,showInactiveCompanies:false,showOnlyDirectDials:false},companyAppliedFilters);
       }
      });
    }
    companySearchAndFilterChangedAction(searchOptions: SearchOptions,companyFilter: CompanyAppliedFilter[]) {
      this.store.dispatch(SearchCompanyActions.companySearchAndFilterChangedAction({ searchOptions: searchOptions, appliedFilter: companyFilter}));
  }
    ngOnChanges(): void {

        this.employeeRange = E.from(this.filters.employeeRange.items)
            .where(i => i.checked)
            .select(i => i.caption)
            .toArray();

        this.industry = E.from(this.filters.industry.items)
            .where(i => i.checked)
            .select(i => i.caption)
            .toArray();

        this.ownership = E.from(this.filters.ownership.items)
            .where(i => i.checked)
            .select(i => i.caption)
            .toArray();

        this.revenueRange = E.from(this.filters.revenueRange.items)
            .where(i => i.checked)
            .select(i => i.caption)
            .toArray();

        this.location = E.from(this.filters.location.items)
            .where(i => i.checked)
            .select(i => i.caption)
            .toArray();
        this.companyName = E.from(this.filters.companyName.items)
            .where(i => i.checked)
            .select(i => i.caption)
            .toArray();
        this.country = E.from(this.filters.country.items)
          .where(i => i.checked)
          .select(i => i.caption)
          .toArray();
        this.website = E.from(this.filters.website.items)
          .where(i => i.checked)
          .select(i => i.caption)
          .toArray();
    }

    private getFilterName(type:string){

      switch (type) {
        case "website":
            let filterName1: keyof CompanySearchFilters = "website";
            return filterName1;

        case "city":
          let filterName2: keyof CompanySearchFilters = "city";
          return filterName2;

        case "companyName":
          let filterName3: keyof CompanySearchFilters = "companyName";
          return filterName3;

        case "country":
          let filterName4: keyof CompanySearchFilters = "country";
          return filterName4;

        case "countryState":
        let filterName5: keyof CompanySearchFilters = "countryState";
        return filterName5;

        case "employeeRange":
        let filterName6: keyof CompanySearchFilters = "employeeRange";
        return filterName6;

        case "industry":
        let filterName7: keyof CompanySearchFilters = "industry";
        return filterName7;

        case "location":
        let filterName8: keyof CompanySearchFilters = "location";
        return filterName8;

        case "ownership":
        let filterName9: keyof CompanySearchFilters = "ownership";
        return filterName9;

        case "revenueRange":
        let filterName10: keyof CompanySearchFilters = "revenueRange";
        return filterName10;

        case "state":
        let filterName11: keyof CompanySearchFilters = "state";
        return filterName11;
     }

    }

}


